import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      chartData: props.barChartData || [],
      chartOptions: props.barChartOptions || {},
    };
  }

  componentDidUpdate(prevProps) {
    
    if (this.props.barChartData !== prevProps.barChartData) {
      
      this.setState({ chartData: this.props.barChartData });
    }
    if (this.props.barChartOptions !== prevProps.barChartOptions) {
      
      this.setState({ chartOptions: this.props.barChartOptions });
    }
  }

  
    render() {
    // Adicionando uma verificação de segurança extra antes de renderizar
    if (!this.state.chartData || !Array.isArray(this.state.chartData)) {
        console.error("[6f] BarChart: chartData não é um array válido!", this.state.chartData);
        return <div>Erro ao carregar dados do gráfico.</div>;
    }
    return (
      <Chart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="bar"
        width="100%"
        height="100%"
      />
    );
  }
}

export default BarChart;